import { StatusOptions } from "@type/taskManagement/common";
import { SubTasksListTable, SubTasksListHeader } from "./components";

type Props = {
  statusOptions: StatusOptions;
};

const SubTasksList = ({ statusOptions }: Props) => {
  return (
    <div className="p-10">
      <SubTasksListHeader />
      <SubTasksListTable statusOptions={statusOptions} />
    </div>
  );
};

export default SubTasksList;
